<template>
  <div class="manage-content">
    <ValidationObserver ref="refForm" v-slot="{ handleSubmit }" class="manage-content-box">
      <div class="page-header slide-down">
        <h3 class="page-title">{{ $route.query.name }}</h3>
      </div>

      <ValidationProvider name="Add Job" rules="required" v-slot="{ errors }">
        <div class="box input-box slide-left">
          <div class="input-group">
            <div class="field">
              <label for="" class="label">English Name</label>
              <div class="control">
                <input type="text" v-model="addname" class="input" :class="{ error: errors }"
                  placeholder="Type New... " />
              </div>
            </div>

            <div class="field">
              <label for="" class="label">Lao Name</label>
              <div class="control">
                <input type="text" v-model="laoName" class="input" :class="{ error: errors }"
                  placeholder="Type New... " />
              </div>
            </div>
            <div class="field">
              <label for="" class="label">Score</label>
              <div class="control">
                <input type="text" v-model="score" class="input" :class="{ error: errors }" placeholder="Add score... " />
              </div>
            </div>
          </div>
          <button v-if="!isEdit" @click="handleSubmit(addjob)" class="button">
            Add
          </button>
          <button v-else @click="handleSubmit(update)" class="button">
            Update
          </button>
        </div>
      </ValidationProvider>
      <div class="box scroll-y slide-up">
        <div class="box-header">
          <div class="field">
            <input type="text" v-model="Search" class="input" placeholder="Search" required @keyup="searchmanage" />
          </div>
          <custom :total="total" />
        </div>
        <div class="table-container">
          <table class="table">
            <thead class="sticky">
              <tr>
                <th>No.</th>
                <th>English Name</th>
                <th>Laos Name</th>
                <th v-if="jobCheck">No. Jobs</th>
                <th v-if="empCheck">No. Company</th>
                <th>Point(s)</th>
                <th class="is-sm text-right">Setting</th>
              </tr>
            </thead>
            <draggable :list="funcs" tag="tbody" @change="sort()" v-bind="dragOptions" @start="drag = true"
              @end="drag = false">
              <tr v-for="(f, index) in funcs" :key="index">
                <td class="is-sm">{{ index + 1 }}</td>
                <td>{{ f.name }}</td>
                <td>{{ f.laoName }}</td>
                <td v-if="jobCheck">{{ f.jobs.toLocaleString() }}</td>
                <td v-if="empCheck">{{ f.emps.toLocaleString() }}</td>
                <td>{{ f.score }}</td>
                <td class="is-sm text-right">
                  <div class="icon-group">
                    <span @click="pushEdit(index)" :class="{ selected: selectedId === f._id }">
                      <i class="fad fa-pen"></i>
                    </span>
                    <span class="alert" @click="deletejob(f._id, index)">
                      <i class="fad fa-trash"></i>
                    </span>
                  </div>
                </td>
              </tr>
            </draggable>
          </table>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import custom from "../Pagination/customPagination";
import { ADD_REUSE } from "@/graphql/manage/add";
import { GET_REUSE, SORT } from "@/graphql/manage/query";
import { DELETE } from "@/graphql/manage/delete";
import { UPDATE } from "@/graphql/manage/update";
import { apolloClient } from "@/services/apollo-client";

export default {
  components: {
    custom,
    draggable,
  },
  data: () => ({
    modalClick: false,
    funcs: [],
    total: null,
    addname: "",
    reuse: "",
    isEdit: false,
    selectedId: "",
    id: [],
    laoName: "",
    enName: "",
    Search: "",
    score: 0,
    jobCheck: false,
    empCheck: false,
  }),
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    searchmanage() {
      this.$router
        .push({
          query: {
            choose: this.$route.query.choose,
            p: 10,
            q: 1,
            s: this.Search,
          },
        })
        .catch(() => { });
    },
    async openUpdatemodal(id) {
      this.modalClick = true;

      this.$nextTick(() => {
        this.$refs.companyModal.userId = id;
      }, 1000);
    },

    async addjob() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      const res = await apolloClient.mutate({
        mutation: ADD_REUSE,
        variables: {
          name: this.addname,
          laoName: this.laoName,
          type: this.$route.query.choose,
          score: parseInt(this.score ? this.score : 0)
        },
      });
      this.funcs.push(res.data.addReuse);
      this.addname = "";
      this.laoName = "";
      this.score = "";
      this.$refs.refForm.reset();
      this.queryjob();
    },
    async sort() {
      await apolloClient.mutate({
        mutation: SORT,
        variables: {
          items: this.funcs.map((i) => i._id),
          type: this.$route.query.choose,
        },
      });
    },
    async queryjob() {
      //console.log(this.funcs);
      const res = await apolloClient.query({
        query: GET_REUSE,
        variables: {
          name: this.addname,
          laoName: this.laoName,
          type: this.$route.query.choose,
          page: parseInt(this.$route.query.q),
          perPage: parseInt(this.$route.query.p),
          search: this.Search,
        },
      });
      this.funcs = res.data.getReuse.reuseType;
      this.total = res.data.getReuse.totals;
      this.jobCheck = res.data.getReuse.jobCheck;
      this.empCheck = res.data.getReuse.empCheck;
    },
    async update() {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: UPDATE,
        variables: {
          reuseId: this.selectedId,
          name: this.addname,
          laoName: this.laoName,
          score: parseInt(this.score ? this.score : 0),
          type: this.$route.query.choose,
        },
      });

      this.addname = "";
      this.laoName = "";
      this.selectedId = "";
      this.isEdit = false;
      this.score = "";
      this.$refs.refForm.reset();
      this.queryjob();
    },

    pushEdit(index) {
      const obj = this.funcs[index];
      if (obj._id === this.selectedId) {
        this.isEdit = false;
        this.addname = "";
        this.laoName = "";
        this.score = "";
        this.selectedId = "";
        return;
      }
      this.isEdit = true;
      this.addname = obj.name;
      this.laoName = obj.laoName;
      this.score = obj.score;
      this.selectedId = obj._id;
    },

    async deletejob(reuseId, index) {
      const isConfirmed = await this.$dialog.confirm();
      if (!isConfirmed) return;
      await apolloClient.mutate({
        mutation: DELETE,
        variables: {
          reuseId: reuseId,
          type: this.$route.query.choose,
        }
      })

      this.funcs.splice(index, 1);
    },
  },
  watch: {
    "$route.query": {
      async handler() {
        this.queryjob();
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.queryjob();
    this.searchmanage();
  },
};
</script>

<style lang="scss" scoped>
.selected {
  background-color: var(--primary-color) !important;

  i {
    color: #fff !important;
  }
}

.box {
  margin-bottom: 10px;

  .box-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .field {
      margin: 0 !important;
    }
  }
}

.input-box {
  padding: 10px;
  display: flex;

  .input-group {
    display: flex;
    width: 100%;
    align-items: flex-end;

    .field {
      width: 50%;
      flex-grow: 1;
      padding: 0 10px;
      margin: 0 !important;
      display: flex;
      align-items: center;

      label {
        margin: 0 10px 0 0;
        white-space: pre;
        font-size: var(--sm-font);
      }

      .control {
        width: 100%;

        input {
          font-family: var(--font-family);

          &.error {
            border-color: var(--alert-color);
            background-color: rgba(var(--alert-color), 0.1);
          }
        }
      }
    }
  }

  button {
    margin-left: 10px;
    background-color: var(--primary-color);
    color: #fff;
    border: none;

    &:focus {
      box-shadow: none;
      box-shadow: unset;
    }
  }
}

.manage-content {
  padding: 20px;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  .manage-content-box {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-height: 100%;
    min-height: 100%;

    .box.scroll-y {
      min-height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      margin-bottom: 0;
      padding-bottom: 20px;
      flex-grow: 1;

      .table-container {
        overflow-y: auto;
        border-top: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);

        .sticky {
          position: sticky;
          top: 0;
          z-index: 9;
        }
      }
    }
  }
}
</style>
